import { atom } from "jotai"

export const isWeb3AuthenticatedAtom = atom<boolean>(false)
